import { Spin } from 'antd'
import styled from 'styled-components'

export const StyledSpinner = styled(Spin)`
  margin-bottom: -4px;
`
